module.exports = __webpack_public_path__ + "static/scale-model-of-soos-creek-botanical-garden-in-kent-washington-901f73e25320070614280e81954ef5ea.png";